// this file is templated from the build-time environment
// using @rollup/plugin-replace
// @ts-nocheck
export const hostBaseURL = process.env.HOST_BASE_URL;
export const frontendGatewayGraphqlAPIURL = process.env.FRONTEND_GATEWAY_URL;
